import { IJobInfo } from '../JobItem/type'
import { getJobListFromCompany, getSpecialJob } from '../../services/jobService'
import { ELanguage } from '@microfrontends/react-components'

const getFilterParse = (locationId?: number[], companyId?: number) => {
    const filter = []
    filter.push({
        field: 'companyId',
        value: String(companyId)
    })
    filter.push({
        field: 'isAnonymous',
        value: 'false'
    })
    if (Array.isArray(locationId) && locationId.length > 0) {
        filter.push({
            field: 'workingLocations.cityId',
            value: locationId.join(',')
        })
    }

    return filter
}

export const doGetJobList = async (
    companyId: number,
    accessToken: string,
    searchQuery: string,
    page: number,
    locationIds: number[],
    userId?: number,
    hitsPerPage?: number,
    langCode?: ELanguage
) => {
    let jobs: IJobInfo[] = []
    let jobLocations: number[] = []
    let jobTotal = 0
    const filter = getFilterParse(locationIds, companyId)
    const response = await getJobListFromCompany(accessToken || '', filter, page, searchQuery, userId, hitsPerPage, langCode)
    // get list of job id
    const listJobId =
        (response.data &&
            response.data.map((jobItem) => {
                return jobItem.jobId
            })) ||
        []

    // Get special job (matching, applied, saved)
    if (listJobId.length === 0) {
        return { jobs: [], jobTotal: 0 }
    }

    let isLoggedIn = true
    if (accessToken === '') {
        isLoggedIn = false
    }

    if (isLoggedIn) {
        const responseSpecial = await getSpecialJob(listJobId, accessToken || '')
        // Map job with special job
        const mappedJobList =
            response.data &&
            response.data.map((job) => {
                const saveJobArr = responseSpecial.data?.filter((item) => item.id === job.jobId)
                if (saveJobArr && saveJobArr?.length > 0) {
                    job.isApplied = saveJobArr[0].attributes.applied
                    job.isSaved = saveJobArr[0].attributes.saved
                    job.isMatching = saveJobArr[0].attributes.matching
                    job.isBlackList = saveJobArr[0].attributes.userBlackList
                    job.jobInvitation = saveJobArr[0].attributes.jobInvitation ?? { jobInvitationId: 0, status: 0}
                }
                return job
            })
        jobs = mappedJobList || []
    } else {
        jobs = response?.data || []
    }

    if (response && response.meta) {
        jobTotal = response.meta.nbHits || 0
    }

    if (response && response.facets?.cityIds) {
        jobLocations = response.facets?.cityIds
    }

    return {
        jobs,
        jobTotal,
        jobLocations
    }
}
